import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import CreateRFI from './views/createRFI';
import LookupRFI from './views/lookupRFI';
import Listing from './views/listing';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { createBrowserHistory } from 'history';
import Header from './components/header';
import { authContext, withAdalLoginApi } from "./auth/adalConfig";
import { Loading } from './views/loading';
import { ErrorPage } from './views/errorPage';

// removes '#!' from url when the server does its redirection
const history = createBrowserHistory();
const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
if (path) {
    history.replace(path);
}

const clearLocalStorageErrors = () => {
  localStorage.removeItem('adal.error');
  localStorage.removeItem('adal.error.description');
  localStorage.removeItem('adal.login.error');
}

export default function AppWrapper() {
  const [initComplete, setInitComplete] = useState(false);
  
  //on initialization, clear any login related errors to prevent users from needing to clear localStorage manually
  useEffect(() => {
    clearLocalStorageErrors();
    setInitComplete(true);
  }, []);

  return (initComplete ? <App /> : <></>)
}

function App () {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(!!authContext?._user);
  const [loginError, setLoginError] = useState();
  
  // launches a popup for authentication.
  const InternalLogin = withAdalLoginApi(<></>, () => <Loading setLoading={setIsUserLoggedIn} setError={setLoginError}/>, () => <ErrorPage />);
  
  // check local storage for errors 
  useEffect(() => {
    const error = localStorage.getItem('adal.error');
    if (error) {
      setLoginError(localStorage.getItem('adal.error.description'))
    }
    else if (loginError) {
      setLoginError(null);
      clearLocalStorageErrors();
    }
  }, [loginError]);

  // Internal website
  let router = (    
  <Router key={isUserLoggedIn}>
    <div>
      <Header />
      <ToastContainer 
        position="top-center"
        autoClose={ 8000}
        hideProgressBar={ false}
        closeOnClick={true}
        pauseOnHover={true}
      />
      <Switch>        
        <Route path="/rfi/:id">
          {isUserLoggedIn ? <LookupRFI /> : <InternalLogin />}
        </Route>
        <Route path="/error">
          <ErrorPage />
        </Route>
        <Route path="/">
          {isUserLoggedIn ? <Listing /> : <InternalLogin />}
        </Route>
      </Switch>
    </div>
  </Router>);

  // External website
  if(process.env.REACT_APP_ENV === 'external') {
    router = (
      <Router>
        <div>
          <Header />
          <ToastContainer 
            position="top-center"
            autoClose={8000}
            hideProgressBar={ false}
            closeOnClick={true}
            pauseOnHover={true}
          />
          <nav>
            {}
          </nav>

          <Switch>
            <Route path="/">
              <CreateRFI />
              {/* <Test /> */}
            </Route>
          </Switch>
        </div>
      </Router>
    );
  }

  return (router);
    
}

